import { gql } from '@apollo/client'

export const GET_PROJECT_SCHEDULES_FOR_NAV = gql`
  query projectSchedulesForNav_UI($projectId: String!) {
    projectSchedules_admin(projectId: $projectId) {
      id
    }
  }
`

export const GET_PROJECT_SCHEDULES = gql`
  query projectSchedules_UI($projectId: String!) {
    projectSchedules_admin(projectId: $projectId) {
      id
      title
      status

      updatedAt
      earliestDate
      latestDate

      editingAdminUser {
        id
        user {
          id
          firstName
          lastName
        }
      }
    }
  }
`

export const CREATE_PROJECT_SCHEDULE = gql`
  mutation createProjectSchedule_UI(
    $projectId: String!
    $input: CreateProjectScheduleInput_Admin!
  ) {
    createProjectSchedule_admin(projectId: $projectId, input: $input) {
      id
    }
  }
`

export const SUBBIE_PROJECT_SCHEDULES = gql`
  query subbieProjectSchedules_UI($subcontractorId: String!) {
    subcontractorProjectSchedules_public(subcontractorId: $subcontractorId) {
      id
      title

      project {
        id
        status
        name
        timezone
        locale

        builder {
          id
          logoUrl
          company {
            name
          }
          defaultLocale
          defaultTimezone
        }
      }
    }
    publicSubcontractor(id: $subcontractorId) {
      id
      company {
        name
        abn
      }
      builder {
        id
        logoUrl
        company {
          name
        }
        defaultLocale
        defaultTimezone
      }
    }
  }
`

const SUBBIE_ITEM_FRAGMENT = gql`
  fragment SubbieProjectScheduleItem on ProjectScheduleItem_Public {
    id
    confirmedAt
    title
    description
    startDate
    duration
  }
`

export const SUBBIE_PROJECT_SCHEDULE_ITEMS = gql`
  query subbieProjectSchedule_UI(
    $subcontractorId: String!
    $projectScheduleId: String!
  ) {
    subcontractorProjectSchedule_public(
      subcontractorId: $subcontractorId
      projectScheduleId: $projectScheduleId
    ) {
      id
      title

      project {
        id
        name
        timezone
        locale
        status

        builder {
          id
          logoUrl
          company {
            name
          }
          defaultLocale
          defaultTimezone
        }

        projectContacts {
          id
          type
          name
          email
          number
        }
      }

      items {
        ...SubbieProjectScheduleItem
      }
    }
    publicSubcontractor(id: $subcontractorId) {
      id
      company {
        name
        abn
      }
      builder {
        id
        logoUrl
        company {
          name
        }
        defaultLocale
        defaultTimezone
      }
    }
  }
  ${SUBBIE_ITEM_FRAGMENT}
`

export const SUBBIE_CONFIRM_PROJECT_SCHEDULE_ITEM = gql`
  mutation subbieConfirmProjectScheduleItem_UI(
    $subcontractorId: String!
    $projectScheduleItemId: String!
  ) {
    confirmProjectScheduleItem_public(
      subcontractorId: $subcontractorId
      projectScheduleItemId: $projectScheduleItemId
    ) {
      ...SubbieProjectScheduleItem
    }
  }
  ${SUBBIE_ITEM_FRAGMENT}
`
